import { render, staticRenderFns } from "./ReportGratificationCartas.vue?vue&type=template&id=118edad4&scoped=true&"
import script from "./ReportGratificationCartas.vue?vue&type=script&lang=js&"
export * from "./ReportGratificationCartas.vue?vue&type=script&lang=js&"
import style0 from "./ReportGratificationCartas.vue?vue&type=style&index=0&id=118edad4&lang=scss&scoped=true&"
import style1 from "./ReportGratificationCartas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118edad4",
  null
  
)

export default component.exports